import { FieldPlayer } from '@/components';
import {
  EnumTeamContext,
  PlayerClub,
  PlayerHistoric,
  TacticOnField,
  TemplatePlayer,
  Player,
} from '@/types/team';
import { TACTICS_ARR } from '@/utils';

type GetPlayersOnFieldOptions = {
  idTactic: number;
  team: PlayerClub[] | PlayerHistoric[] | Player[];
  context?: EnumTeamContext;
  handleSelectPlayer: (
    player: PlayerClub | TemplatePlayer,
    toBeChanged?: boolean
  ) => void;
};

export const useTeam = () => {
  const getPlayersOnField = (options: GetPlayersOnFieldOptions) => {
    const { handleSelectPlayer, idTactic, team, context } = options;

    const tactic = idTactic;

    const players = {
      defenders: [],
      midfielders: [],
      forwards: [],
      goalkeepers: null,
      substitutes: [],
    } as TacticOnField;

    players.defenders = [];
    players.midfielders = [];
    players.forwards = [];

    const tacticArray: number[] = TACTICS_ARR[tactic];

    let position = 0;

    const isScoreField = context === EnumTeamContext.Score11;
    const isChange = context === EnumTeamContext.Changes11;

    for (let i = 0; i <= tacticArray.length; i++) {
      const positionOnField: number = tacticArray[i];
      for (let j = 0; j < positionOnField; j++) {
        const counterPosition = ++position;
        if (i === 0) {
          players.defenders.push(
            <FieldPlayer
              context={context}
              data={team[counterPosition]}
              id={String(counterPosition + 1)}
              positionLabel="DEF"
              onClick={() =>
                !isScoreField &&
                handleSelectPlayer(
                  {
                    ...team[counterPosition],
                    posicion: { nombreCorto: 'DEF', id: 2 },
                  },
                  isChange
                )
              }
            />
          );
        } else if (i === 1) {
          players.midfielders.push(
            <FieldPlayer
              context={context}
              data={team[counterPosition]}
              id={String(counterPosition + 1)}
              positionLabel="VOL"
              onClick={() =>
                !isScoreField &&
                handleSelectPlayer(
                  {
                    ...team[counterPosition],
                    posicion: { nombreCorto: 'VOL', id: 3 },
                  },
                  isChange
                )
              }
            />
          );
        } else {
          players.forwards.push(
            <FieldPlayer
              context={context}
              data={team[counterPosition]}
              id={String(counterPosition + 1)}
              positionLabel="DEL"
              onClick={() =>
                !isScoreField &&
                handleSelectPlayer(
                  {
                    ...team[counterPosition],
                    posicion: { nombreCorto: 'DEL', id: 4 },
                  },
                  isChange
                )
              }
            />
          );
        }
      }
    }

    players.goalkeepers = (
      <FieldPlayer
        context={context}
        data={team[0]}
        id="1"
        positionLabel="ARQ"
        onClick={() => {
          !isScoreField &&
            handleSelectPlayer({
              ...team[0],
              posicion: { nombreCorto: 'ARQ', id: 1 },
            });
        }}
      />
    );

    players.substitutes = [
      <FieldPlayer
        key={11}
        context={context}
        data={team[11]}
        id="11"
        positionLabel="ARQ"
        onClick={() => {
          !isScoreField &&
            handleSelectPlayer({
              ...team[11],
              posicion: { nombreCorto: 'ARQ', id: 1 },
            });
        }}
      />,
      <FieldPlayer
        key={12}
        context={context}
        data={team[12]}
        id="12"
        positionLabel="DEF"
        onClick={() => {
          !isScoreField &&
            handleSelectPlayer({
              ...team[12],
              posicion: { nombreCorto: 'DEF', id: 2 },
            });
        }}
      />,
      <FieldPlayer
        key={13}
        context={context}
        data={team[13]}
        id="13"
        positionLabel="VOL"
        onClick={() => {
          !isScoreField &&
            handleSelectPlayer({
              ...team[13],
              posicion: { nombreCorto: 'VOL', id: 3 },
            });
        }}
      />,
      <FieldPlayer
        key={14}
        context={context}
        data={team[14]}
        id="14"
        positionLabel="DEL"
        onClick={() => {
          !isScoreField &&
            handleSelectPlayer({
              ...team[14],
              posicion: { nombreCorto: 'DEL', id: 4 },
            });
        }}
      />,
    ];

    return players;
  };

  return { getPlayersOnField };
};
